import { useOnClickOutside } from '@Shared/Hook/UseOnClickOutside.js';
import usePortal from '@Shared/Hook/UsePortal.js';
import Portal from '@Shared/HOC/Portal.js';
import PropTypes from 'prop-types';
import { useRef } from 'react';

function Dropdown({
    btn,
    children,
    width,
    isOpened,
    setIsOpened,
    disabled = false,
    className = '',
    btnClassName = '',
}) {
    const { coords, updateTooltipCoords } = usePortal();

    const refDropdown = useRef(null);
    const btnRef = useRef(null);

    useOnClickOutside([refDropdown, btnRef], () => setIsOpened(false));

    const handleToggle = (e) => {
        e.stopPropagation();

        setIsOpened((prevState) => !prevState);

        updateTooltipCoords(e.target, width);
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div
                className={`${disabled ? 'pointer-events-none' : ''} ${btnClassName}`}
                ref={btnRef}
                onClick={handleToggle}
            >
                {btn}
            </div>
            {isOpened && (
                <Portal>
                    <div
                        ref={refDropdown}
                        className={`absolute left-auto z-50`}
                        style={{ ...coords }}
                    >
                        {children}
                    </div>
                </Portal>
            )}
        </div>
    );
}

Dropdown.propTypes = {
    btn: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    width: PropTypes.number.isRequired,
    isOpened: PropTypes.bool.isRequired,
    setIsOpened: PropTypes.func.isRequired,
};

export default Dropdown;
